import { gql } from 'apollo-angular';

export var delete_blocked_committee_date = gql`
  mutation deleteBlockedCommitteeDate($id: ID!) {
    deleteBlockedCommitteeDate(id: $id) {
      id
      date
    }
  }
`;
